module.exports = __webpack_public_path__ + "img/logo.ea5dd544.png";